module.exports = __webpack_public_path__ + "static/media/ankita_karhade.49fdc8ba.png";